import GeneralView from '~/generalView';
import Handlebars from 'handlebars';

import EventHub from '~/eventHub';
import Settings from '~/settings.js';
import users_template from '~/templates/users.handlebars';
import toastr from 'toastr';
import getUserService from '~/services/userService';
import getUtilsService from '~/services/utilsService';

/**
 * Category View (show category title and a report ranking of a report)
 * @constructor
 * @type {*}
 */
var UsersView = GeneralView.View.extend({
	/**
	* @member [html] tagName
	*/
	tagName: "div",
	/**
	* @member [User] className
	*/
	className: 'User',
	/**
	* @member [number] userId
	*/
	userId:'',
	/**
	* @member [User] user
	*/
	user: null,
	currentuser: null,
	users: [],
	roles: [],
	delObj: null,
	fadeId: null,
	dataId: null,
	/**
	* @ignore
	* @constructor
	*/
	initialize: function () {
		toastr.options = {
			"closeButton": true,
			"debug": false,
			"newestOnTop": true,
			"progressBar": false,
			"positionClass": "toast-top-center",
			"preventDuplicates": false,
			"onclick": null,
			"showDuration": "300",
			"hideDuration": "1000",
			"timeOut": "5000",
			"extendedTimeOut": "1000",
			"showEasing": "swing",
			"hideEasing": "linear",
			"showMethod": "fadeIn",
			"hideMethod": "fadeOut"
		}
	},

	events: {
		'click .delete':'removeUser',
		'click .hide_data':'showEdit',
		'click .discard_changes_role':'discardChangesRole',
		'click .save_role':'saveRole',
		'click .discard_changes_email':'discardChangesEmail',
		'click .save_email':'saveEmail',
		'click .save_username':'saveUsername',
		'click .discard_changes_username':'discardChangesUsername',
		'click .new_psw':'generatePassword',
		'click .usertrazline' : 'gototimelineuser',
		'click .activateuser':'activateUser',
		'click .deactivateuser':'deactivateUser',
    },

    /**
     *
     * @function render
     * @return {ProfileView}
     */
    render: function () {
    	this.renderUsers();
    	return this;
    },

	renderUsers: function(e){
    	this.attachEvents();
		$('#myModal').hide();
    	$('.modal-backdrop').hide();
		this.currentuser = Parse.User.current();
    },

    gototimelineuser: function(e){
    	var data = $(e.currentTarget).attr('id').split('-');
		var id = data[0];
		var username = data[1];
    	location.href = "#timeline?kind=user&id="+id+'&username='+username;
    },

	/**
	*
	* @function attachEvents
	*/
	attachEvents: function() {
		var that = this;
		var handlebarsTemplate = Handlebars.template(users_template);
		this.$el.html(handlebarsTemplate());
		this.$el.find('.content').hide();
		var permissions = getUtilsService.getprofilepermissions();
		var usersPromise = getUserService().fetch({
			all: true,
			cache: false
		}).then(data => {
			var params =  { userrol: Parse.User.current().attributes.role};
			if (Settings.shogunmonitorapp && !permissions.accessallreports) {
				params.shogunmonitorapp = true;
			};
			Parse.Cloud.run("getroles", params).then((allroles) => {
				var selectOptions = allroles;
				that.roles = allroles;
				that.users = data.models;
				Parse.Cloud.run("getallusers", params).then((allusersxc) => {
					var usersforadmin = [];
					usersforadmin.models = allusersxc;
					var that = this;
					that.users = usersforadmin.models;
					if (getUtilsService.getprofilepermissions().consultusers) {
						var options = {
							//weekday: 'long',
							year: 'numeric',
							month: 'short',
							day: 'numeric'
						};
						var langdate = lang + "-GB";
						for (var u = 0; u < usersforadmin.models.length; u++) {
							usersforadmin.models[u].creationdate = usersforadmin.models[u].attributes.createdAt.toLocaleDateString(langdate, options);
						}
						var handlebarsTemplate = Handlebars.template(users_template);
						this.$el.html(handlebarsTemplate(usersforadmin));
						$('.usersloader').hide();
						$('.delete#'+Parse.User.current().id).prop('disabled', true);
						$('.activateuser#'+Parse.User.current().id).prop('disabled', true);
						$('.deactivateuser#'+Parse.User.current().id).prop('disabled', true);
						if (!permissions.editusers) {
							this.disableeditfields();
						}
						for (var u = 0; u < usersforadmin.models.length; u++) {
							var selectInfo = '';
							for(var x = 0; x < selectOptions.length; x++){
								if(usersforadmin.models[u].attributes.role == selectOptions[x].attributes.name){
									selectInfo += '<option value="'+selectOptions[x].attributes.name+'" class="item" selected>'+selectOptions[x].attributes.name+'</option>';
								}
								else{
									selectInfo += '<option value="'+selectOptions[x].attributes.name+'" class="item">'+selectOptions[x].attributes.name+'</option>';
								}
							}
							this.$el.find('#input_role'+usersforadmin.models[u].id).html(selectInfo);
						}
					}
					else{
						data.models = that.users;
						data = this.dateforusers(data);
						this.$el.html(handlebarsTemplate(data));
						$('.delete#'+Parse.User.current().id).prop('disabled', true);
						if (!permissions.editusers) {
							this.disableeditfields();
						}
						for (var u = 0; u < data.models.length; u++) {
							var selectInfo = '';
							for(var x = 0; x < selectOptions.length; x++){
								if(data.models[u].attributes.role == selectOptions[x].attributes.name){
									selectInfo += '<option value="'+selectOptions[x].attributes.name+'" class="item" selected>'+selectOptions[x].attributes.name+'</option>';
								}
								else{
									selectInfo += '<option value="'+selectOptions[x].attributes.name+'" class="item">'+selectOptions[x].attributes.name+'</option>';
								}
							}
							this.$el.find('#input_role'+data.models[u].id).html(selectInfo);
						}
					}
					if (getUtilsService.getprofilepermissions().trazabilidaduser != true) {
						$(".usertrazline").hide();
					}
				},
				(error) => {
					console.log(error);
					switch(error.code){
						case 100:
							toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
						break;
					}
				});
				this.translate();
			},
			(error) => {
				console.log(error);
				switch(error.code){
					case 100:
						toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
					break;
				}
			});
		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
	},

	disableeditfields: function(){
		$('.delete').prop('disabled', true);
		$('.new_psw').prop('disabled', true);
		$('.activateuser').prop('disabled', true);
		$('.deactivateuser').prop('disabled', true);
		$('.hide_data').hide();
	},

	dateforusers: function(users){
		var options = {
			year: 'numeric',
			month: 'short',
			day: 'numeric'
		};
		var langdate = lang + "-GB";
		for (var i = 0; i < users.models.length; i++) {
			users.models[i].creationdate = users.models[i].attributes.createdAt.toLocaleDateString(langdate, options);
		}
		return users;
	},

	removeUser: function(e){
		var id = $(e.currentTarget).attr('id');
		this.delObj = $(e.currentTarget).parent().parent();
		var that = this;
		toastr.options.timeOut = "0";
		toastr.options.extendedTimeOut = "0";
		var txt = '<span>'+ arrlang[lang]["RemoveUser"] +'</span><br><button class="btntoastr btnaccept" id="'+ id +'">'+ arrlang[lang]["ToastrAccept"] +'</button><button class="btntoastr btncancel">'+ arrlang[lang]["ToastrCancel"] +'</button>';
		this.toastrButtons(txt, 'warning');
		$('.btnaccept').one("click", function(e){
			that.acceptButtonRemoveUser(e);
		});
		$('.btncancel').one("click", function(){
			that.cancelButtonRemoveUser();
		});
	},
	
	acceptButtonRemoveUser: function(e){
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
		var that = this;
		var id = $(e.currentTarget).attr('id');
		for(var i=0; i < this.users.length; ++i){
			if(this.users[i].id == id){
				Parse.Cloud.run("DeleteUser", { "id": id }).then(function(result) {
					toastr.success(arrlang[lang]["UserDeleted"], "Operación realizada");
					that.users.splice(i, 1);
					that.delObj.remove();
				},
				(error) => {
					console.log(error);
					switch(error.code){
						case 100:
							toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
						break;
					}
				});
			}
		}
	},
	
	cancelButtonRemoveUser: function(){
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
	},

	showEdit: function(e){
		var fadeId = e.currentTarget.parentElement.id;
		var showId = e.currentTarget.parentElement.nextElementSibling.id;
		$('#'+fadeId).fadeOut("fast");
		$('#'+showId).show("fast");
	},

	discardChangesRole: function(e){
		var fadeId = e.currentTarget.parentElement.parentElement.id;
		var selectId = e.currentTarget.parentElement.parentElement.firstElementChild.id;
		var dataId = e.currentTarget.parentElement.parentElement.previousElementSibling.id;
		$('#'+selectId).empty();
		var tempRole = $('#'+dataId).text().replace(/\n/g, '').replace(/\t/g, '');
		var selectInfo = '';
		for(var x = 0; x < this.roles.length; x++){
			if(tempRole == this.roles[x].attributes.name){
				selectInfo += '<option value="'+this.roles[x].attributes.name+'" class="item" selected>'+this.roles[x].attributes.name+'</option>';
			}
			else{
				selectInfo += '<option value="'+this.roles[x].attributes.name+'" class="item">'+this.roles[x].attributes.name+'</option>';
			}
		}
		 $('#'+selectId).append(selectInfo);
		$('#'+fadeId).fadeOut("fast");
		$('#'+dataId).show("fast");
	},

	discardChangesEmail: function(e){
		var id = e.currentTarget.id;
		var emailcontainer = "data_field_email" + id;
		var editemailcontainer = "edit_field_email" + id;
		var useremail = $("#"+emailcontainer).text();
		var inputemail = "input_email" +id;
		$('#'+inputemail).val(useremail);
		$('#'+editemailcontainer).fadeOut("fast");
		$('#'+emailcontainer).show();
	},

	discardChangesUsername: function(e){
		var id = e.currentTarget.id;
		var usercontainer = "data_field_username" + id;
		var editusercontainer = "edit_field_username" + id;
		var username = $("#"+usercontainer).text();
		var inputusername = "input_username" +id;
		$('#'+inputusername).val(username);
		$('#'+editusercontainer).fadeOut("fast");
		$('#'+usercontainer).show();
	},

	saveEmail: function(e){
		var id = $(e.currentTarget).attr('id');
		var that = this;
		toastr.options.timeOut = "0";
		toastr.options.extendedTimeOut = "0";
		var txt = '<span>'+ arrlang[lang]["ChangeUserEmail"] +'</span><br><button class="btntoastr btnaccept" id="'+ id +'">'+ arrlang[lang]["ToastrAccept"] +'</button><button class="btntoastr btncancel">'+ arrlang[lang]["ToastrCancel"] +'</button>';
		this.toastrButtons(txt, 'sucess');
		$('.btnaccept').one("click", function(e){
			that.acceptButtonSaveEmail(e);
		});
		$('.btncancel').one("click", function(){
			that.cancelButtonSaveEmail();
		});
	},
	
	acceptButtonSaveEmail: function(e){
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
		var id = $(e.currentTarget).attr('id');
		var inputemail = "input_email" +id;
		var newEmail = $('#'+inputemail).val();
		var emailcontainer = "data_field_email" + id;
		var editemailcontainer = "edit_field_email" + id;
		Parse.Cloud.run("editEmailUser", { 'id': id,"email": newEmail }).then(function(result) {
			toastr.success("Correo electrónico actualizado");
		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
		$('#'+emailcontainer).html(newEmail+'<i class="hide_data fa fa-pencil-square fa-lg pull-right actionicons" aria-hidden="true"></i>');
		$('#'+editemailcontainer).fadeOut("fast");
		$('#'+emailcontainer).show("fast");
	},
	
	cancelButtonSaveEmail: function(){
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
	},

	saveUsername: function(e){
		var id = $(e.currentTarget).attr('id');
		var that = this;
		toastr.options.timeOut = "0";
		toastr.options.extendedTimeOut = "0";
		var txt = '<span>'+ arrlang[lang]["ChangeUserUsername"] +'</span><br><button class="btntoastr btnaccept" id="'+ id +'">'+ arrlang[lang]["ToastrAccept"] +'</button><button class="btntoastr btncancel">'+ arrlang[lang]["ToastrCancel"] +'</button>';
		this.toastrButtons(txt, 'sucess');
		$('.btnaccept').one("click", function(e){
			that.acceptButtonSaveUsername(e);
		});
		$('.btncancel').one("click", function(){
			that.cancelButtonSaveUsername();
		});
	},
	
	acceptButtonSaveUsername: function(e){
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
		var id = $(e.currentTarget).attr('id');
		var inputusername = "input_username" +id;
		var newusername = $('#'+inputusername).val();
		var usercontainer = "data_field_username" + id;
		var editusercontainer = "edit_field_username" + id;
		Parse.Cloud.run("editUserName", { 'id': id,"username": newusername }).then(function(result) {
			toastr.success("Nombre de usuario actualizado");
		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
		$('#'+usercontainer).html(newusername+'<i class="hide_data fa fa-pencil-square fa-lg pull-right actionicons" aria-hidden="true"></i>');
		$('#'+editusercontainer).fadeOut("fast");
		$('#'+usercontainer).show("fast");
	},
	
	cancelButtonSaveUsername: function(){
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
	},

	saveRole: function(e){
		var id = e.currentTarget.parentElement.parentElement.firstElementChild.id;
		this.fadeId = e.currentTarget.parentElement.parentElement.id;
		this.dataId = e.currentTarget.parentElement.parentElement.previousElementSibling.id;
		var that = this;
		toastr.options.timeOut = "0";
		toastr.options.extendedTimeOut = "0";
		var txt = '<span>'+ arrlang[lang]["ChangeUserRole"] +'</span><br><button class="btntoastr btnaccept" id="'+ id +'">'+ arrlang[lang]["ToastrAccept"] +'</button><button class="btntoastr btncancel">'+ arrlang[lang]["ToastrCancel"] +'</button>';
		this.toastrButtons(txt, 'sucess');
		$('.btnaccept').one("click", function(e){
			that.acceptButtonSaveRole(e);
		});
		$('.btncancel').one("click", function(){
			that.cancelButtonSaveRole();
		});
	},
	
	acceptButtonSaveRole: function(e){
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
		var id = $(e.currentTarget).attr('id');
		var fadeId = this.fadeId;
		var dataId = this.dataId;
		var newRole = $('#'+id).val();
		var id = dataId.replace('data_field_role', '');
		Parse.Cloud.run("editRoleUser", { 'id': id,'role': newRole }).then(function(result) {
			toastr.success("Rol de usuario actualizado");
		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
		$('#'+dataId).html(newRole+'<i class="hide_data fa fa-pencil-square fa-lg pull-right actionicons" aria-hidden="true"></i>');
		$('#'+fadeId).fadeOut("fast");
		$('#'+dataId).show("fast");
	},
	
	cancelButtonSaveRole: function(){
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
	},

	generatePassword: function(e){
		var id = $(e.currentTarget).attr('id').replace('new_psw','');
		var that = this;
		toastr.options.timeOut = "0";
		toastr.options.extendedTimeOut = "0";
		var txt = '<span>'+ arrlang[lang]["ChangeUserPswd"] +'</span><br><button class="btntoastr btnaccept" id="'+ id +'">'+ arrlang[lang]["ToastrAccept"] +'</button><button class="btntoastr btncancel">'+ arrlang[lang]["ToastrCancel"] +'</button>';
		this.toastrButtons(txt, 'sucess');
		$('.btnaccept').one("click", function(e){
			that.acceptButtonNewPswd(e);
		});
		$('.btncancel').one("click", function(){
			that.cancelButtonNewPswd();
		});
	},
	
	acceptButtonNewPswd: function(e){
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
		var id = $(e.currentTarget).attr('id');
		Parse.Cloud.run("generatePassword", { 'id': id }).then(function(result) {
			if (result == 'OK') {
				toastr.success("Contraseña de ingreso generada");
			}
		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
	},
	
	cancelButtonNewPswd: function(){
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
	},

	activateUser: function(e){
		var id = $(e.currentTarget).attr('id');
		var that = this;
		toastr.options.timeOut = "0";
		toastr.options.extendedTimeOut = "0";
		var txt = '<span>'+ arrlang[lang]["ActivateUserQ"] +'</span><br><button class="btntoastr btnaccept" id="'+ id +'">'+ arrlang[lang]["ToastrAccept"] +'</button><button class="btntoastr btncancel">'+ arrlang[lang]["ToastrCancel"] +'</button>';
		this.toastrButtons(txt, 'sucess');
		$('.btnaccept').one("click", function(e){
			that.acceptButtonActivateUser(e);
		});
		$('.btncancel').one("click", function(){
			that.cancelButtonActivateUser();
		});
	},
	
	acceptButtonActivateUser: function(e){
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
		var that = this;
		var id = $(e.currentTarget).attr('id');
		Parse.Cloud.run("activateUser", { 'id': id }).then(function(result) {
			toastr.success(arrlang[lang]["ActivateUserA"]);
			that.renderUsers();
		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
	},
	
	cancelButtonActivateUser: function(){
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
	},

	deactivateUser: function(e){
		var id = $(e.currentTarget).attr('id');
		var that = this;
		toastr.options.timeOut = "0";
		toastr.options.extendedTimeOut = "0";
		var txt = '<span>'+ arrlang[lang]["DeactivateUserQ"] +'</span><br><button class="btntoastr btnaccept" id="'+ id +'">'+ arrlang[lang]["ToastrAccept"] +'</button><button class="btntoastr btncancel">'+ arrlang[lang]["ToastrCancel"] +'</button>';
		this.toastrButtons(txt, 'sucess');
		$('.btnaccept').one("click", function(e){
			that.acceptButtonDeactivateUser(e);
		});
		$('.btncancel').one("click", function(){
			that.cancelButtonDeactivateUser();
		});
	},
	
	acceptButtonDeactivateUser: function(e){
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
		var that = this;
		var id = $(e.currentTarget).attr('id');
		Parse.Cloud.run("deactivateUser", { 'id': id }).then(function(result) {
			toastr.success(arrlang[lang]["DeactivateUserA"]);
			that.renderUsers();
		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
	},
	
	cancelButtonDeactivateUser: function(){
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
	},
});

export default UsersView;
